import React from 'react';
import OutfitCreation from "../components/OutfitCreation/OutfitCreation";

const OutfitMaker = () => {
    return (
        <div>
           <OutfitCreation />
        </div>
    );
};

export default OutfitMaker;